import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'

const copy = {
  overline: `Privacy Portal`,
  heading: `Data privacy, automated`,
  description: `We believe data privacy is a right. Your customers probably do, too. With the Segment Privacy Portal, you can automate your approach to keeping your customers' data private.`,
}

const Hero: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <HeroComponent variant="2Col">
        <HeroRecipe.Copy>
          <CopyTextBase>
            <CopyText.Overline>{copy.overline}</CopyText.Overline>
            <CopyText.Heading variant="h1" tag="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pLarge" tag="p">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
          <FormWrapper>
            <DemoForm
              data-hook="demoFormContainer"
              isProgressive={true}
              customFormIdentifier="site-privacyportal-demo"
              successMessageAppearance="twilioLight"
            />
          </FormWrapper>
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <Picture>
            <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x`} />
            <HeroRecipe.Image width="640" height="482" src={heroPng2x} alt="Illustration: Privacy Portal" />
          </Picture>
        </HeroRecipe.Contents>
      </HeroComponent>
    </Wrapper>
  )
}

const FormWrapper = styled(HeroRecipe.Form)`
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    margin-left: 0;
  }
`

const Wrapper = styled.header`
  position: relative;
  z-index: 0;
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

const HeroComponent = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      row-gap: 24px;
      padding-top: 40px;
      padding-bottom: 30px;
    }
  }
`

const Picture = styled.picture`
  padding: 10px 20px 30px;
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default Hero
